

// Utility: Fade In Animation
function fadeIn(element, duration = 300) {
  element.style.display = 'block';
  element.style.opacity = '0';
  
  let start = null;
  function animate(timestamp) {
    if (!start) start = timestamp;
    const progress = timestamp - start;
    element.style.opacity = Math.min(progress / duration, 1);
    
    if (progress < duration) {
      requestAnimationFrame(animate);
    }
  }
  requestAnimationFrame(animate);
}

// Utility: Hide element
function hide(element) {
  element.style.display = 'none';
}

// Utility: Show element
function show(element) {
  element.style.display = 'block';
}

// Update Cart Bubble
function updateCartBubble(increment = 1) {
  const bubble = document.querySelector(".cart-count-bubble");
  if (!bubble) return;

  const countEl = bubble.querySelector('span[aria-hidden="true"]');
  const hiddenEl = bubble.querySelector(".visually-hidden");

  let currentCount = parseInt(countEl.textContent.trim()) || 0;
  let newCount = currentCount + increment;

  countEl.textContent = newCount;
  hiddenEl.textContent = `${newCount} Artikel`;

  bubble.classList.remove("hidden");
}

// Add variant to cart
async function addToCart(button) {
  const variantId = button.dataset.variantId;
  const originalText = button.innerHTML;

  button.disabled = true;
  button.innerHTML = 'Wird hinzugefügt…';

  try {
      const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
      },
      body: JSON.stringify({
          id: variantId,
          quantity: 1,
      }),
      });

      if (!response.ok) {
      const errorData = await response.json();
      console.error('Cart add error:', errorData);
      // Fehlerzustand im Button anzeigen
      button.innerHTML = 'Fehler';
      setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
      }, 2000);
      return;
      }

      const cartItem = await response.json();
      console.log('Erfolgreich hinzugefügt:', cartItem);

      button.innerHTML = 'Hinzugefügt';

      
      const drawer = document.querySelector(".drawer");
      updateCartBubble(1);
      setTimeout(() => {
        drawer.refresh(true);
      }, 550);

      // Optional: Nach kurzer Zeit wieder zurück zum Originaltext
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 2000);
  } catch (error) {
      console.error('Network/cart error:', error);
      button.innerHTML = 'Fehler';
      setTimeout(() => {
      button.innerHTML = originalText;
      button.disabled = false;
      }, 2000);
  }
}

// Initialize App
document.addEventListener("DOMContentLoaded", function () {
  console.log("etxUi initialised");
  
  // Shopify Theme Editor Mode
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    const reinitSliders = () => {
      etxSwiper();
    };

    document.addEventListener("shopify:section:load", reinitSliders);
    document.addEventListener("shopify:section:reorder", reinitSliders);
    document.addEventListener("shopify:section:unload", reinitSliders);
  }

  // Initialize Lenis Smooth Scroll
  
  if (typeof Lenis !== 'undefined') {
    window.lenis = new Lenis({
      wheelMultiplier: 1.35,
      autoResize: true
    });

    function raf(time) {
      window.lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    const safeResizeLenis = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.lenis?.resize();
        });
      });
    };

    window.addEventListener('load', safeResizeLenis);
    window.addEventListener('resize', safeResizeLenis);

    const observer = new MutationObserver(() => {
      safeResizeLenis();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }


  // Initialize Modules
  const selectors = {
    scrollytelling: '[data-module="ScrollytellingVision"]',
    accordion: '.Accordion',
    filter: '.FlexListingWithFilter',
    swiper: '.swiper',
    parallax: '.parallax'
  };

  if (document.querySelector(selectors.scrollytelling)) etxScrollyTelling();
  if (document.querySelector(selectors.accordion)) etxAccordion();
  if (document.querySelector(selectors.filter)) etxFilter();
  if (document.querySelector(selectors.swiper)) etxSwiper();
  if (document.querySelector(selectors.parallax)) etxParallax();

  if (typeof etxLazyLoad === 'function') etxLazyLoad();

  /*** ALLGEMEIN ***/

  // Ankündigungleiste ganz oben einberechnen
  const announcementBar = document.querySelector(".announcement-bar-section");
  if (announcementBar) {
    etxScrollClass(
      window,
      announcementBar,
      document.body,
      60,
      "top",
      "up"
    );
  }

  // Header Navigation Scroll Behavior
  const header = document.querySelector("header");
  const htmlElement = document.documentElement;
  let delay = 0;
  let lastScrollTop = 0;
  let position_top = 0;

  // Initial scroll position
  let st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > lastScrollTop && st > delay) {
    header?.classList.add("translated");
  } else {
    header?.classList.remove("translated");
  }

  if (st < 120) {
    header?.classList.add("top");
  } else {
    header?.classList.remove("top");
  }
  lastScrollTop = st;

  // Scroll Event Handler
  window.addEventListener("scroll", function () {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    
    if (st > lastScrollTop && st > delay) {
      header?.classList.add("translated");
    } else {
      header?.classList.remove("translated");
    }

    if (st < 120) {
      header?.classList.add("top");
    } else {
      header?.classList.remove("top");
    }
    
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  });

  // Header Navigation Toggle
  const headerNavToggle = document.querySelector(".HeaderNavToggle");
  if (headerNavToggle) {
    headerNavToggle.addEventListener("click", function (e) {
      if (htmlElement.classList.contains("nav-show")) {
        htmlElement.classList.remove("nav-show");
      } else {
        const headerSearchLinks = document.querySelectorAll(".HeaderSearch a");
        headerSearchLinks.forEach(link => link.classList.remove("active"));
        
        htmlElement.classList.add("nav-show");
        
        document.querySelectorAll(".HeaderExpandable__inner").forEach(el => hide(el));
        
        const topnav = document.querySelector(".HeaderExpandable__topnav");
        if (topnav) fadeIn(topnav);
      }
    });
  }

  // Back Button in Expandable Overview
  const backButton = document.querySelector(".HeaderExpandableOverview__back");
  if (backButton) {
    backButton.addEventListener("click", function () {
      document.querySelectorAll(".HeaderExpandable__inner").forEach(el => hide(el));
      
      const topnav = document.querySelector(".HeaderExpandable__topnav");
      if (topnav) fadeIn(topnav);
    });
  }

  // Hide all Header Expandable Inner elements initially
  document.querySelectorAll(".HeaderExpandable__inner").forEach(el => hide(el));

  // Mobile Drawer Split Click Handler
  document.addEventListener("click", function (event) {
    const splitElement = event.target.closest("#MobileDrawer .Split");
    
    if (splitElement) {
      const columns = splitElement.dataset.columns;

      if (!splitElement.classList.contains("active")) {
        document.querySelectorAll("#MobileDrawer .Split").forEach(el => {
          el.classList.remove("active");
        });
        splitElement.classList.add("active");

        const productGrid = document.querySelector("#product-grid");
        if (productGrid) {
          if (columns == 2 && productGrid.classList.contains("c-1")) {
            productGrid.classList.remove("c-1");
            productGrid.classList.add("c-2");
          } else if (columns == 1 && productGrid.classList.contains("c-2")) {
            productGrid.classList.remove("c-2");
            productGrid.classList.add("c-1");
          }
        }
      }
    }
  });

  // Global Click Handler for Navigation and Popup
  document.addEventListener("click", function (event) {
    // Close navigation if click outside header
    if (
      !event.target.closest("header") &&
      htmlElement.classList.contains("nav-show")
    ) {
      htmlElement.classList.remove("nav-show");
      
      document.querySelectorAll(".HeaderNav a, .HeaderNav span").forEach(el => {
        el.classList.remove("active");
      });
      
      document.querySelectorAll(".HeaderExpandable__inner").forEach(el => hide(el));
    }

    // Close sizes popup if click outside
    const sizesPopup = document.querySelector("#SizesPopup");
    if (
      sizesPopup &&
      sizesPopup.style.display !== "none" &&
      !event.target.closest(".PopupInner, .togglePopup")
    ) {
      hide(sizesPopup);
      htmlElement.classList.remove("overflow-hidden");
      document.removeEventListener("keydown", handleKeydown);
    }
  });

  // Header Navigation and Search Click Handlers
  const navSearchElements = document.querySelectorAll(".HeaderNav a[data-nav-expandable], .HeaderNav span, .HeaderSearch a, .HeaderSearch span");
  navSearchElements.forEach(element => {
    element.addEventListener("click", function (event) {
      event.stopPropagation();
      event.preventDefault();
      
      const currentNav = this.dataset.navExpandable;
      
      if (header) {
        header.setAttribute("data-open", currentNav);
      }

      if (this.classList.contains("active")) {
        this.classList.remove("active");
        htmlElement.classList.remove("nav-show");
        document.querySelectorAll(".HeaderExpandable__inner").forEach(el => hide(el));
      } else {
        // Remove active from all
        navSearchElements.forEach(el => el.classList.remove("active"));
        
        // Hide all expandable inners
        document.querySelectorAll(".HeaderExpandable__inner").forEach(el => hide(el));

        // Add active to clicked element
        this.classList.add("active");
        htmlElement.classList.add("nav-show");

        // Show the corresponding expandable content
        const expandableContent = document.querySelector(
          `.HeaderExpandable__inner[data-nav-expandable-content="${currentNav}"]`
        );
        if (expandableContent) fadeIn(expandableContent);
      }
    });
  });

  // Header Top Navigation Click Handlers
  const topnavElements = document.querySelectorAll(".HeaderExpandable__topnav a, .HeaderExpandable__topnav span");
  topnavElements.forEach(element => {
    element.addEventListener("click", function (event) {
      event.stopPropagation();
      event.preventDefault();
      
      const currentNav = this.dataset.navExpandable;
      
      if (header) {
        header.setAttribute("data-open", currentNav);
      }

      // Remove active from all nav/search elements
      navSearchElements.forEach(el => el.classList.remove("active"));
      
      // Hide all expandable inners
      document.querySelectorAll(".HeaderExpandable__inner").forEach(el => hide(el));

      // Add active to clicked element
      this.classList.add("active");
      htmlElement.classList.add("nav-show");

      // Show the corresponding expandable content
      const expandableContent = document.querySelector(
        `.HeaderExpandable__inner[data-nav-expandable-content="${currentNav}"]`
      );
      if (expandableContent) fadeIn(expandableContent);
    });
  });

  // Header Language Button
  const languageButton = document.querySelector(".HeaderLanguage__button");
  if (languageButton) {
    languageButton.addEventListener("click", function () {
      const headerLanguage = this.closest(".HeaderLanguage");
      if (headerLanguage) {
        headerLanguage.classList.toggle("active");
      }
    });
  }

  // Trim Language Switcher Links
  const langSwitcherLinks = document.querySelectorAll(".HeaderLanguage .lang_switcher_link");
  langSwitcherLinks.forEach(link => {
    const currentText = link.textContent.split(" ");
    link.textContent = currentText[0];
  });

  // Check for Hero Element
  const firstHero = document.querySelector(".Hero");
  if (firstHero && firstHero.scrollTop === 0) {
    htmlElement.classList.add("has-hero");
  }
});

// Window Resize Handler
window.addEventListener("resize", function () {
  if (typeof etxRecalcPathLengths === 'function') {
    etxRecalcPathLengths();
  }

  const htmlElement = document.documentElement;
  if (window.innerWidth > 1000 && htmlElement.classList.contains("nav-show")) {
    htmlElement.classList.remove("nav-show");
    
    const headerMobileNav = document.querySelector(".HeaderMobileNav");
    if (headerMobileNav) hide(headerMobileNav);
  }
});

// Window Load Handler
window.addEventListener("load", function () {
  if (typeof etxLazyLoad === 'function') {
    etxLazyLoad();
  }
});

// Mobile Layout zweispaltig / einspaltig
document.addEventListener("click", function (event) {
  const clickedType = event.target.closest("#MobileLayout .Split");
  if (!clickedType) return;

  const columns = clickedType.dataset.columns;
  const productGrid = document.getElementById("product-grid");

  if (!clickedType.classList.contains("active")) {

    document
      .querySelectorAll("#MobileLayout .Split")
      .forEach(el => el.classList.remove("active"));

    clickedType.classList.add("active");

    if (columns == 2 && productGrid.classList.contains("mob-m:c-2")) {
      productGrid.classList.remove("mob-m:c-2");
      productGrid.classList.add("c-2");
    window.scrollBy(0, 1);
window.scrollBy(0, -1);
    } else if (columns == 1 && productGrid.classList.contains("c-2")) {
      productGrid.classList.remove("c-2");
      productGrid.classList.add("mob-m:c-2");
    }
  }
});

